module.exports = __webpack_public_path__ + "img/5.796eeeb5.jpg";